<template>
  <div class="login-wrapper">
    <!-- <div class="language-container">
      <span :class="{ active: language == 'vi' }" @click="setLang('vi')"
        >VI</span
      >
      <span class="divider" />
      <span :class="{ active: language == 'en' }" @click="setLang('en')"
        >EN</span
      >
    </div> -->
    <div class="login-container">
      <div class="logo">
        <img
          src="@/styles/images/mci_logo.png"
          alt="logo"
          style="width: 300px"
        />
      </div>
      <div class="login-box">
        <div class="title-box">
          <div class="title">
            <span>Chào mừng trở lại!</span>
          </div>
          <span>Hệ thống quản lý thông tin MCI</span>
        </div>
        <form @submit.prevent="onLogin">
          <div v-loading="loading" class="login-form">
            <validation-observer ref="formValidator">
              <validation-provider rules="required|max:20" name="Tài khoản">
                <div class="input-data user">
                  <input
                    id="username"
                    v-model="loginData.username"
                    type="text"
                    class="input_name"
                    autofocus="1"
                    name="username"
                    autocomplete="username"
                    placeholder="Nhập thông tin tài khoản"
                  />
                </div>
              </validation-provider>
              <div class="input-data password">
                <validation-provider rules="required" name="Mật khẩu">
                  <input
                    id="password"
                    v-model="loginData.password"
                    :type="isShowPw ? `text` : `password`"
                    placeholder="Nhập mật khẩu"
                    autocomplete="password"
                    class="password"
                    name="password"
                  />
                </validation-provider>

                <div
                  v-if="showEye"
                  class="eye"
                  :class="showPwComp"
                  @click="onTogglePwHide"
                ></div>
              </div>
              <input type="submit" hidden />
            </validation-observer>
            <!-- <div class="checkbox-wrap">
            <input id="saveUserID" v-model="isSaveIdChecked" type="checkbox">
            <label for="saveUserID">{{ $t('login.saveCre') }}</label>
          </div> -->
            <div class="form-actions">
              <button class="btn medium primary" type="submit">
                {{ $t('login.signIn') }}
              </button>
              <!-- <button class="btns large secondary" @click="enrollUser">
              회원가입
            </button> -->
            </div>
            <div class="flex mt-10 justify-end">
              <span
                class="link-btn"
                style="cursor: pointer"
                @click="forgotPwDialog = true"
                >Quên mật khẩu?</span
              >
            </div>
          </div>
        </form>

        <!-- <div class="forgot-pass-container">
          <div class="row">
            <span>{{ $t('login.fotgotPass') }}</span>
            <span style="font-weight: 600; margin-left: 5px">Reset</span>
          </div>
          <div class="row">
            <span>{{ $t('login.dontHaveAcc') }}</span>
            <span style="font-weight: 600; margin-left: 5px">{{
              $t('login.signUp')
            }}</span>
          </div>
        </div> -->
      </div>
    </div>
    <el-dialog
      title="Quên mật khẩu"
      :visible.sync="forgotPwDialog"
      :close-on-click-modal="false"
      width="500px"
    >
      <span>Bạn cần liên hệ với quản trị viên - IT để lấy lại mật khẩu</span>
      <!-- <ul style="line-height: 1.5">
        <li>Tên: Ngô Bá Trường</li>
        <li>Phòng ban: Công nghệ thông tin</li>
        <li>Số điện thoại: 0986.123.123</li>
        <li>Email: truong.ngoba@mci.vn</li>
      </ul> -->
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            style="margin-right: 10px"
            class="btn primary small"
            @click="forgotPwDialog = false"
          >
            Đã hiểu
          </button>
        </div>
      </span>
    </el-dialog>
    <el-dialog
      title="Đặt lại mật khẩu"
      :visible.sync="needChangePwd"
      :close-on-click-modal="false"
      width="400px"
    >
      <validation-observer ref="formValidator1">
        <div class="das-form-container reset-password">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider
                  rules="required"
                  :name="$t('login.password')"
                >
                  <div class="das-form-input">
                    <div class="label required">
                      {{ this.$t('login.password') }}
                    </div>
                    <div class="child-w-80 password">
                      <input
                        v-model="loginData.new_password"
                        :type="showEyeNew ? `password` : `text`"
                      />
                      <div
                        class="eye"
                        :class="showEyeNew ? '' : 'hidden'"
                        @click="showEyeNew = !showEyeNew"
                      ></div>
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider
                  :rules="`required|confirmed:${$t('login.password')}`"
                  name="Nhập lại mật khẩu"
                >
                  <div class="das-form-input">
                    <div class="label required">
                      {{ $t('login.confirmPassword') }}
                    </div>
                    <div class="child-w-80 password">
                      <input
                        v-model="loginData.cf_pwd"
                        :type="showEyeConfirm ? `password` : `text`"
                      />
                      <div
                        class="eye"
                        :class="showEyeConfirm ? '' : 'hidden'"
                        @click="showEyeConfirm = !showEyeConfirm"
                      ></div>
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            style="margin-right: 10px"
            class="btn primary small"
            @click="needChangePwd = false"
          >
            Huỷ
          </button>
          <button class="btn primary small outline" @click="changePwd()">
            Lưu
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  // setIsLogin,
  // getIdPassword,
  setIdPassword,
  deleteLogInfo,
  setToken,
  saveUserData
  // setUserRole
} from '@/utils/auth'
import {
  loginApi,
  changePasswordApi,
  getUserListPathApi,
  getAuthorizedListApi,
  getUserInfo
} from '@/api/auth_service/login.js'
// import { setLanguage, getLanguage } from '@/utils/cookies'
// import bus from '@/utils/bus.js'
export default {
  components: {},
  data() {
    return {
      forgotPwDialog: false,
      showEye: false,
      showEyeNew: true,
      showEyeConfirm: true,
      isShowPw: false,
      loading: false,
      needChangePwd: false,
      loginData: {
        username: '',
        password: '',
        new_password: '',
        cf_pwd: ''
      },
      isSaveIdChecked: false
    }
  },
  computed: {
    language() {
      // return getLanguage()
      return null
    },
    showPwComp() {
      if (this.isShowPw) {
        return 'hidden'
      } else {
        return 'show'
      }
    }
  },
  watch: {
    needChangePwd() {
      this.needChangePwd ? null : this.resetUpdatePwForm()
    },
    isSaveIdChecked: function (val) {
      if (!val) {
        deleteLogInfo()
      }
    },
    'loginData.password'(val) {
      if (val.length > 0) {
        this.showEye = true
      } else {
        this.showEye = false
      }
    }
    // 'loginData.new_password'(val) {
    //   if (val.length > 0) {
    //     this.showEyeNew = true
    //   } else {
    //     this.showEyeNew = false
    //   }
    // },
    // 'loginData.cf_pwd'(val) {
    //   if (val.length > 0) {
    //     this.showEyeConfirm = true
    //   } else {
    //     this.showEyeConfirm = false
    //   }
    // }
  },
  created() {
    // this.checkUserSaved()
  },
  methods: {
    resetUpdatePwForm() {
      this.loginData.new_password = ''
      this.loginData.cf_pwd = ''
    },
    onTogglePwHide() {
      this.isShowPw = !this.isShowPw
    },
    async changePwd() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator1)) === false) {
        return
      }
      await changePasswordApi(this.loginData)
        .then(res => {
          this.$message({
            message: 'Đổi mật khẩu thành công',
            type: 'success'
          })
          this.loginData.password = this.loginData.new_password
          this.loginData.new_password = null
          this.onLogin()
        })
        .catch(error => {
          const msg = error.response?.data?.message || 'default'
          this.$message({
            message: this.$t(`errorMsg.${msg}`),
            type: 'error'
          })
        })
    },
    setLang(lang) {
      // setLanguage(lang)
    },
    enrollUser() {
      this.$router.push('enrollment')
    },
    saveUserIdPassword() {
      if (this.isSaveIdChecked) {
        const logData = {
          userId: this.loginData.username,
          userPwd: this.loginData.password
        }
        setIdPassword(logData)
      } else {
        deleteLogInfo()
      }
    },
    async onLogin() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      this.loading = true
      await loginApi(this.loginData)
        .then(async res => {
          const needChangePwd = res.data?.need_change_password
          const msg = res.data?.message
          if (needChangePwd) {
            this.$vxAlert(this.$t(`login.${msg}`), () => {
              this.needChangePwd = true
            })
          } else {
            const token = res.data?.token
            token ? setToken(token) : null
            this.$message({
              message: 'Đăng nhập thành công',
              type: 'success'
            })
            await this.fnGetUserInfo()
            const listPath = await getUserListPathApi()
            if (listPath.data && Boolean(listPath.data.length)) {
              localStorage.setItem('listPath', JSON.stringify(listPath.data))
            }
            const a2 = await getAuthorizedListApi()
            const authorizedList = []
            a2.data.forEach(item => {
              if (item.inUse) {
                authorizedList.push(item.code)
              }
            })
            localStorage.setItem(
              'authorizedList',
              JSON.stringify(authorizedList)
            )
            this.$router.push('/')
          }
        })
        .catch(err => {
          const message = err.response?.data?.message || 'defaultErrorMsg'
          this.$message({
            message: this.$t(`errorMsg.${message}`),
            type: 'error'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    async fnGetUserInfo() {
      try {
        const res = await getUserInfo()
        console.log(res.data)
        saveUserData(res.data)
      } catch (error) {
        const message = error.response?.data?.message || 'default'
        this.$message({
          type: 'error',
          message: this.$t(`message.error.${message}`)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.language-container {
  position: fixed;
  width: 100px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 20px;
  top: 20px;
  .divider {
    width: 2px;
    height: 15px;
    background: white;
    margin: 0 10px;
    display: inline-block;
  }
  span {
    color: white;
    font-size: 18px;
    font-weight: 500;
    cursor: pointer;
    &.active {
      color: #164f2c;
    }
  }
}
.link-btn {
  &:hover {
    text-decoration: underline;
  }
}

.reset-password .eye {
  background: url('/img/mci_eye_icon.79366ede.svg') no-repeat;
  width: 20px;
  height: 20px;
  cursor: pointer;
  display: inline-block;
  position: absolute;
  top: 8px;
  right: 10px;
}

.reset-password .eye.hidden {
  background: url(/img/mci_eye_slash_icon.82252ddc.svg) no-repeat;
}
</style>
